import React from "react";
import Slider from "react-slick";

interface CarouselProps {
  children?: React.ReactNode;
  slidesCount?: number;
  dots?: boolean;
  arrows?: boolean;
}

export function Carousel(props: CarouselProps) {
  const { children, slidesCount, dots, arrows } = props;

  return (
    <Slider
      arrows={!!arrows}
      dots={dots === undefined || dots}
      slidesToShow={slidesCount}
    >
      {children}
    </Slider>
  );
}
